const AVAILABLE_IMAGE_SIZES = [50, 100, 200, 400];

export default (url, size) => {
  if (!url) {
    return null;
  }

  if (!url.includes('qcqcdn.com')) {
    const bestSize = AVAILABLE_IMAGE_SIZES.find(availableSize => size <= availableSize);

    if (bestSize) {
      return url.replace('product/', `product/${bestSize}/`);
    }

    return url;
  }

  return `${url}?w=${size}&h=${size}`;
};
